/**
 * Strips HTML tags and decodes common entities from CMS/WYSIWYG content,
 * for safe use in meta description / og:description / twitter:description.
 * Raw HTML must never be passed to Next.js Metadata fields.
 */
export function stripHtml(html: string | null | undefined, maxLength?: number): string {
    if (!html) return '';
    const text = html
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'")
        .replace(/\s+/g, ' ').trim();
    if (!maxLength) return text;
    return text.length > maxLength ? `${text.slice(0, maxLength).trim()}…` : text;
}
